import ConditionalRuleSet from "~/models/conditionalRules/conditionalRuleSet";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import {ConditionalFieldDefinition} from "./conditionalFieldDefinition";
import MultiSourceConditionalRule from "~/models/conditionalRules/multiSourceConditionalRule";
import {IMultiSourceConditionalRuleContainer} from "~/models/conditionalRules/conditionalRuleContainer";

export default class MultiSourceConditionalRuleSet extends ConditionalRuleSet {
  static repo: IRepo<MultiSourceConditionalRuleSet> = new Repo('multiSourceConditionalRuleSets', MultiSourceConditionalRuleSet);
  container: IMultiSourceConditionalRuleContainer;

  constructor(fieldName: string, definition: ConditionalFieldDefinition, container: IMultiSourceConditionalRuleContainer) {
    super(fieldName, definition);
    this.container = container;
    this.except.push('container');
  }

  createNew(fieldName: string, conditionalFieldDefinition: ConditionalFieldDefinition): ConditionalRuleSet {
    return new MultiSourceConditionalRuleSet(fieldName, conditionalFieldDefinition, this.container);
  }

  createNewRule(): MultiSourceConditionalRule {
    return new MultiSourceConditionalRule(this.container);
  }
}